import { cn } from "helpers/classNames";
import React, { FC } from "react";

interface Props {
  children: React.ReactNode;
  isFirstColumn?: boolean;
  isLastColumn?: boolean;
  hideOnMobile?: boolean;
  hideOnTablet?: boolean;
  hideOnSmallTablet?: boolean;
  isLink?: boolean;
}

export const TD: FC<
  Props &
    React.DetailedHTMLProps<
      React.TableHTMLAttributes<HTMLTableCellElement>,
      HTMLTableCellElement
    >
> = ({
  children,
  className,
  isFirstColumn = false,
  isLastColumn = false,
  hideOnMobile = false,
  hideOnTablet = false,
  hideOnSmallTablet = false,
  isLink = false,
  ...rest
}) =>
  isLink ? (
    <td
      className={cn(
        "relative z-[1] whitespace-nowrap py-4 pl-3 pr-4 text-right text-base font-medium sm:pr-6",
        className,
      )}
    >
      {children}
    </td>
  ) : (
    <td
      {...rest}
      className={cn(
        "z-[1] text-base sm:text-sm",
        hideOnTablet
          ? "hidden lg:table-cell"
          : hideOnSmallTablet
            ? "hidden md:table-cell"
            : hideOnMobile && "hidden sm:table-cell",
        isFirstColumn
          ? "whitespace-nowrap py-2 pl-4 pr-3 text-gray-900 sm:pl-6"
          : isLastColumn
            ? "flex justify-end whitespace-nowrap py-2 pl-4 pr-4 font-medium sm:pr-6"
            : "whitespace-nowrap px-3 py-2 text-gray-900",
        className,
      )}
    >
      {children}
    </td>
  );
